export const EMAIL_PATTERN: string = '^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$'
export const PHONE_PATTERN: string = '^(?:\\+\\d{1,3}\\s?)?(?:(\\(\\d{1,4}\\)))?(?:[-.\\s]?)?\\d{1,4}[-.\\s]?\\d{1,4}[-.\\s]?\\d{1,9}$'